import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ApartmentService } from 'src/app/_services/apartments/apartment.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-handoverdetails',
  templateUrl: './handoverdetails.component.html',
  styleUrls: ['./handoverdetails.component.css']
})
export class HandoverdetailsComponent {

  items = [
    { label: 'View Details' }
  ];

  handover:any;

  constructor(
    private apartmentService: ApartmentService,
    private messageService: MessageService,
    private activeRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadHandoverDetails();
    console.log('Handover Details loaded');
  }

  loadHandoverDetails() {
    const id = this.activeRoute.snapshot.paramMap.get('id');

    if(id){
      this.apartmentService.getHandoverDetails(id).subscribe({
        next: (res: any) => {
          console.log('response : ' , res);
          this.handover = res;
          console.log('response id : ', this.handover?.handover_ID );
        },
        error: (err) => {
          console.error(err);
        }
      });
    }

  }

  getIconName(placeName: string = ''): string {
  const name = placeName.toLowerCase().trim();

  switch (true) {
    // Bedrooms: يلقط أي صيغ شائعة
    case /bedroom|bed room|single|double|triple|trible|shared/.test(name):
      return '/assets/images/bedroomIcon.svg';

    // Bathroom / WC / Toilet
    case /bath|toilet|wc/.test(name):
      return '/assets/images/bathIcon.svg';

    // Living room / Reception / Salon
    case /living|reception|salon/.test(name):
      return '/assets/images/livingIcon.svg';

    // Kitchen
    case /kitchen|kitch/.test(name):
      return '/assets/images/KitchenIcon.svg';

    default:
      return '/assets/images/KitchenIcon.svg'; // fallback
  }
}


  showSide: string = '';

   addItem(value: string): void {
    this.showSide = value;
  }

  handelCancle(){
    // this.router.navigate(['/handover-flow']);
  }

}
